// extracted by mini-css-extract-plugin
export var form = "Form-module--form--2aNRr";
export var form__fields = "Form-module--form__fields--1I5X4";
export var textarea = "Form-module--textarea--3fYm1";
export var form__btnWrap = "Form-module--form__btnWrap--2jWdB";
export var inModalBtn = "Form-module--inModalBtn--2SpSS";
export var form__btnWrap__btn = "Form-module--form__btnWrap__btn--1rNek";
export var form__field = "Form-module--form__field--NlS79";